import httpClient from './httpClient';

// Legacy ephemeral report (kept for compatibility)
const getReport = async (startDate, endDate) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
  };

  const response = await httpClient.get('/api/reports/quality-capacity', { params });
  return response.data;
};

// Legacy direct export (kept for compatibility)
const exportReport = async (startDate, endDate) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
  };

  const response = await httpClient.get('/api/reports/quality-capacity/export', {
    params,
    responseType: 'blob',
  });

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;

  const contentDisposition = response.headers['content-disposition'];
  let fileName = `质量与产能报表_${startDate}_${endDate}.xlsx`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match) {
      fileName = decodeURIComponent(match[1]);
    }
  }

  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Report runs (preferred Web UI flow)
const createRun = async (startDate, endDate) => {
  const response = await httpClient.post('/api/reports/quality-capacity/runs', {
    start_date: startDate,
    end_date: endDate,
  });
  return response.data;
};

const getRuns = async (page = 1, pageSize = 20) => {
  const response = await httpClient.get('/api/reports/quality-capacity/runs', {
    params: { page, page_size: pageSize },
  });
  return response.data;
};

const getRun = async (runId) => {
  const response = await httpClient.get(`/api/reports/quality-capacity/runs/${runId}`);
  return response.data;
};

const exportRun = async (runId) => {
  const response = await httpClient.get(
    `/api/reports/quality-capacity/runs/${runId}/export`,
    { responseType: 'blob' }
  );

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;

  const contentDisposition = response.headers['content-disposition'];
  let fileName = `质量与产能报表_${runId}.xlsx`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match) {
      fileName = decodeURIComponent(match[1]);
    }
  }

  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const qualityCapacityReportService = {
  getReport,
  exportReport,
  createRun,
  getRuns,
  getRun,
  exportRun,
};

export default qualityCapacityReportService;
